import { ChangeHistoryBannerFieldName, ChangeHistoryCampaignFieldName, ChangeHistoryType } from 'utils/constants/admin';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsLoad = boolean;

export interface EventType {
    addedValues: string | null;
    changeSource: string | null;
    changeTime: string;
    fieldName: ChangeHistoryCampaignFieldName & ChangeHistoryBannerFieldName;
    newValue: string | null;
    oldValue: string | null;
    realUserId: number | null;
    realUserName: string | null;
    removedValues: string | null;
    userId: number;
    userIpAddress: string;
    userName: string;
}

// ----------------------- actions -------------------------------------
const SET_SHOW_CHANGE_HISTORY_MODAL = 'SET_SHOW_CHANGE_HISTORY_MODAL';
const SET_CHANGE_HISTORY_EVENTS = 'SET_CHANGE_HISTORY_EVENTS';
const SET_CHANGE_HISTORY_TYPE = 'SET_CHANGE_HISTORY_TYPE';

interface PayloadTypes {
    [SET_SHOW_CHANGE_HISTORY_MODAL]: IsLoad;
    [SET_CHANGE_HISTORY_EVENTS]: EventType[];
    [SET_CHANGE_HISTORY_TYPE]: ChangeHistoryType;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setShowModal = ActionCreator(SET_SHOW_CHANGE_HISTORY_MODAL);
export const setEvents = ActionCreator(SET_CHANGE_HISTORY_EVENTS);
export const setType = ActionCreator(SET_CHANGE_HISTORY_TYPE);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface ChangeHistoryState {
    isShow: boolean;
    events: EventType[];
    historyType: ChangeHistoryType;
}

export const CHANGE_HISTORY_INITIAL_STATE: ChangeHistoryState = {
    isShow: false,
    events: [],
    historyType: ChangeHistoryType.Campaign,
};

export default createReducer<ChangeHistoryState, PayloadTypes>(CHANGE_HISTORY_INITIAL_STATE, {
    [SET_SHOW_CHANGE_HISTORY_MODAL]: (state, { payload }) => ({
        ...state,
        isShow: payload,
    }),
    [SET_CHANGE_HISTORY_EVENTS]: (state, { payload }) => ({
        ...state,
        events: payload,
    }),
    [SET_CHANGE_HISTORY_TYPE]: (state, { payload }) => ({
        ...state,
        historyType: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
